// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import * as React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import VisaInfoCard from './VisaInfoCard';
import { makeStyles } from '@mui/styles';
import { NO_VALID_VISA_AVAILABLE_ID, VISA_NOT_APPLICABLE_ID } from '../../Config';
import { useState, useEffect } from 'react';
import "../../css/SelectVisaDialog.scss"

const useStyles = makeStyles(() => ({
    paper: { minWidth: "750px" },
}));

function SelectVisaDialog(props) {

    const { open, options, selectedVisaValue, onClose, isDataLoading, email } = props
    const [selectedVisa, setSelectedVisa] = useState(selectedVisaValue)
    const classes = useStyles();

    const handleVisaChange = (event, value) => {
        setSelectedVisa(value)
    }

    useEffect(() => {
        setSelectedVisa(selectedVisaValue)
    }, [selectedVisaValue])

    const handleClose = (isSubmit) => {
        if(isSubmit) {
            onClose(isSubmit, selectedVisa);
        }
        else{
            setSelectedVisa(null)
            onClose(isSubmit, null);
        }
    };

    return (
        <Dialog onClose={() => handleClose(false)} open={open} classes={{ paper: classes.paper }} className="Visa-dialog">
            <div className='Dialog-div'>

                <div className='Dialog-title'>Select Visa</div>
                <Autocomplete
                    className='Autocomplete'
                    loading={isDataLoading}
                    noOptionsText={!isDataLoading ? "No Visa" : "Loading..."}
                    size="small"
                    value={selectedVisa}
                    options={options}
                    getOptionLabel={(option) => option.label}
                    // getOptionDisabled={(option) => option.status === "expired"}
                    onChange={handleVisaChange}
                    renderOption={(props, option) => (
                        <Box key={option.id} {...props} sx={{ fontSize: 17 }} style={{ fontSize: 15, color: option.status === "expired" ? "red" : null }}>{option.label}</Box>
                    )}
                    renderInput={(params) => <TextField  {...params} label="Select VISA" />}
                />
                {selectedVisa && selectedVisa.id && (selectedVisa.id !== NO_VALID_VISA_AVAILABLE_ID.id) && (selectedVisa.id !== VISA_NOT_APPLICABLE_ID.id) && <div className="Visa-info-card"><VisaInfoCard id={selectedVisa.id} email={email} status={selectedVisa.status} /></div>}

                <Button variant="contained" color="secondary" disabled={(!selectedVisa) || (selectedVisa.status === "expired")} className="Submit-button" onClick={() => handleClose(true)}>Select</Button>
                <Button variant="outlined" color="primary" className="Reset-button" onClick={() => handleClose(false)}>Cancel</Button>
            </div>
        </Dialog>
    );
}

export default SelectVisaDialog;
